let baseURL, apiURL, apiHrvURL, appURL, billingURL, facebookId, facebookScope, googleId, amplitudeApiKey, sentryURL, googleSiteVerification, serviceUserToken, welltoryAnalyticsURL;

if (process.env.CONFIG_ENV === 'master') {
  baseURL = 'https://api.welltory.com';
  apiURL = 'https://api.welltory.com';
  apiHrvURL = 'https://hrv-service.welltory.com';
  appURL = 'https://app.welltory.com';
  billingURL = 'https://billing-external.welltory.com'
  facebookId = '269601236762011';
  facebookScope = 'public_profile,email,user_birthday,user_gender';
  googleId = '664157767509-gj3246n8e6f5jtfg8t0c4ch8ous1eob6.apps.googleusercontent.com';
  sentryURL = 'https://dd08dfd5edc04948bf3543b041cf2397@sentry.welltory.com/28';
  googleSiteVerification = 'inK5kjIP9ulhoVRZy7EeTwyjLBNfo2fP3GtZBlEW4Vw';
  serviceUserToken = 'ffffffffffff1';
  welltoryAnalyticsURL = 'https://analytics.welltory.com';
}
else if (process.env.CONFIG_ENV === 'develop') {
  baseURL = 'https://stage-api.welltory.com';
  apiURL = 'https://stage-api.welltory.com';
  apiHrvURL = 'https://stage-hrv-service.welltory.com';
  appURL = 'https://stage-app.welltory.com';
  billingURL = 'https://stage-billing-external.welltory.com';
  facebookId = '732492926938650';
  facebookScope = 'public_profile,email';
  googleId = '664157767509-gj3246n8e6f5jtfg8t0c4ch8ous1eob6.apps.googleusercontent.com';
  serviceUserToken = 'ffffffffffff1';
  sentryURL = 'https://dd08dfd5edc04948bf3543b041cf2397@sentry.welltory.com/28';
  welltoryAnalyticsURL = 'https://stage-analytics.welltory.com';
}
else {
  baseURL = 'https://stage-api.welltory.com';
  apiURL = 'https://stage-api.welltory.com';
  apiHrvURL = 'https://stage-hrv-service.welltory.com';
  appURL = 'http://local-dashboard.welltory.com:3000';
  billingURL = 'https://stage-billing-external.welltory.com';
  facebookId = '732492926938650';
  facebookScope = 'public_profile,email';
  googleId = '664157767509-gj3246n8e6f5jtfg8t0c4ch8ous1eob6.apps.googleusercontent.com';
  serviceUserToken = 'ffffffffffff1';
  welltoryAnalyticsURL = 'https://stage-analytics.welltory.com';
}

amplitudeApiKey = process.env.AMPLITUDE_API_KEY;

export { baseURL, apiURL, apiHrvURL, appURL, billingURL, facebookId, facebookScope, googleId, amplitudeApiKey, sentryURL, googleSiteVerification, serviceUserToken, welltoryAnalyticsURL };
